import http from "@/api/config"; //axios
import { Message } from "element-ui";
const getUserInfo = function (tenantId) {

    return new Promise(function (resolve, reject) {

        http.post("/api/TokenAuth/SetUserMessage", {
            code: "j1t2q3k!l@f#n.p*t",
        }).then((sumres) => {
            http.get("/api/services/app/User/GetUserInfo")
                .then((gui) => {
                    localStorage.setItem("loginName", gui.data.result.name);
                    localStorage.setItem(
                        "emergencyContact",
                        gui.data.result.emergencyContact
                    );
                    Message({
                        message: "登录成功",
                        type: "success",
                        duration: 2000,
                    });
                    if (tenantId) {
                        http.post("/api/services/app/Tenant/GetTenantInfo", {
                            id: tenantId,
                        }).then((res) => {
                            if (res.data.success) {
                                const rtnResult = res.data.result;
                                localStorage.setItem(
                                    "tenantStyle",
                                    rtnResult.tenantStyle
                                );
                                // console.log(rtnResult);
                                localStorage.setItem(
                                    "isTransportDiseaseResistant",
                                    rtnResult.isTransportDiseaseResistant
                                ); // 是否抗疫运输公司
                                http.post(
                                    "/api/services/app/Tenant/GetAuditMessage",
                                    {
                                        id: tenantId,
                                    }
                                ).then((resAudit) => {
                                    var isAudit = resAudit.data.result.isAudit;
                                    // 获取时间判断是不是第一次审核
                                    http.get(
                                        "/api/services/xcx/LoginJudge/GetMessage"
                                    ).then((times) => {
                                        // loading.close();
                                        // setTimeout(() => {
                                        //     loading.close();
                                        //     that.$router.push({
                                        //         path: "/home",
                                        //     });
                                        // }, 2000);

                                        //首次登录，先修改信息
                                        if (
                                            times.data.result.tenant
                                                .lastModificationTime == null ||
                                            times.data.result.tenant
                                                .lastModificationTime == ""
                                        ) {
                                            localStorage.setItem("roles", 0); //information
                                        } else {
                                            if (
                                                times.data.result.tenant.name ==
                                                "云南省交通厅"
                                            ) {
                                                localStorage.setItem(
                                                    "name",
                                                    times.data.result.tenant.name
                                                );
                                                localStorage.setItem("roles", 7);
                                                resolve(true);
                                            }
                                            if (isAudit == true) {
                                                switch (times.data.result.tenant.tenantStyle) {
                                                    case 6: //银行
                                                        localStorage.setItem("roles", 6); //financial-assistance
                                                        break;
                                                    case 9: //保险公司
                                                        localStorage.setItem("roles", 9); //insurance
                                                        break;
                                                    default:
                                                        localStorage.setItem("roles", 8); //默认 firm
                                                        break;
                                                }
                                            } else {
                                                localStorage.setItem("roles", 0); //information
                                            }

                                        }
                                        resolve(true);
                                    })
                                        .catch((errors) => {
                                            reject(errors);
                                        });
                                })
                                    .catch((errors) => {
                                        reject(errors);
                                    });
                            } else {
                                resolve(true);
                            }
                        })
                            .catch((errors) => {
                                reject(errors);
                            });
                    } else {
                        if (
                            gui.data.result.post == "运政管理" ||
                            gui.data.result.post == "抗疫管理" ||
                            gui.data.result.post == "抗疫客服" ||
                            gui.data.result.post == "厅综合管理" ||
                            gui.data.result.post == "云南省交通厅"
                        ) {
                            if (
                                typeof gui.data.result.typeId !== "undefined" &&
                                gui.data.result.typeId !== null
                            )
                                localStorage.setItem(
                                    "typeId",
                                    gui.data.result.typeId
                                );
                            // 记录运政登录进来是省级账号还是市或者县
                            if (
                                typeof gui.data.result.area !== "undefined" &&
                                gui.data.result.area !== null
                            )
                                localStorage.setItem("area", gui.data.result.area);
                            if (
                                typeof gui.data.result.twoArea !== "undefined" &&
                                gui.data.result.twoArea !== null
                            )
                                localStorage.setItem(
                                    "twoArea",
                                    gui.data.result.twoArea
                                );
                            if (
                                typeof gui.data.result.threeArea !== "undefined" &&
                                gui.data.result.threeArea !== null
                            )
                                localStorage.setItem(
                                    "threeArea",
                                    gui.data.result.threeArea
                                );

                            localStorage.setItem("name", gui.data.result.post);
                        }
                      
                        switch (gui.data.result.post) {
                            case "运政管理":
                                localStorage.setItem("roles", 2);
                                break;
                            case "抗疫管理":
                                localStorage.setItem("roles", 3);
                                break;
                            case "抗疫客服":
                                localStorage.setItem("roles", 4);
                                break;
                            case "厅综合管理":
                                localStorage.setItem("roles", 5);
                                break;
                            case "云南省交通厅":
                                localStorage.setItem("roles", 7);
                                break;
                            case "管理金融帮扶":
                                localStorage.setItem("roles", 10);

                                break;
                            case "管理专项贷款":
                                localStorage.setItem("roles", 11);

                                break;
                            case "帮扶车主":
                                localStorage.setItem("roles", 12);
                                break;
                            case "税局":
                                localStorage.setItem("roles", 13);
                                break;
                                
                            default:
                                localStorage.setItem("roles", 1);
                                break;

                        }

                        resolve(true);
                    }
                }).catch(err => {
                    reject(err);
                });
        }).catch(err => {
            reject(err);
        });
    })


}


export default {
    getUserInfo
}